import { MIN_DATE_TIME_STRING } from '@totem/components/ticketing/ticketing';
import { isNull } from '@totem/utilities/common';

const MS_PER_MINUTE = 60 * 1000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

export const parseDisplayDate = (dateIn: string | null | undefined) => {
  if (
    isNull(dateIn) ||
    dateIn === '' ||
    dateIn === MIN_DATE_TIME_STRING ||
    dateIn === '0001-01-01T00:00:00Z'
  ) {
    return null;
  }

  const parsed = new Date(dateIn);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

// Elapsed days to one decimal place — matches the server-side ageD calculation
// used by the Open Tickets Dashboard.
export const ageInDays = (date: Date, now: Date = new Date()) =>
  Math.round(((now.getTime() - date.getTime()) / MS_PER_DAY) * 10) / 10;

const startOfDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

export const formatRelativeDate = (date: Date, now: Date = new Date()) => {
  const elapsed = now.getTime() - date.getTime();
  if (elapsed < 0) {
    return date.toLocaleDateString();
  }

  const calendarDays = Math.round(
    (startOfDay(now) - startOfDay(date)) / MS_PER_DAY,
  );

  if (calendarDays === 0) {
    if (elapsed < MS_PER_MINUTE) {
      return 'Just now';
    }
    if (elapsed < MS_PER_HOUR) {
      return `${Math.floor(elapsed / MS_PER_MINUTE)} min ago`;
    }
    return `${Math.floor(elapsed / MS_PER_HOUR)} h ago`;
  }
  if (calendarDays === 1) {
    return 'Yesterday';
  }
  if (calendarDays < 60) {
    return `${calendarDays} d ago`;
  }
  if (calendarDays < 365) {
    return `${Math.floor(calendarDays / 30)} mo ago`;
  }
  return `${Math.floor(calendarDays / 365)} y ago`;
};
